//import { Injectable } from '@angular/core';
import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { catchError, map, tap, delay } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { AppConfig } from '../../app.config';
import { Observable, of } from 'rxjs';
import { CoreEnvironment } from '@angular/compiler/src/compiler_facade_interface';

// import { LogService } from './log.service';
// import { SecureGuardService } from './security/secure-guard.service';
// import { User } from './security/user';


@Injectable(
  {
  providedIn: 'root'
  }
)
export class SharedService {
 //  _currentUser: User;
  _currentUserEmail: string;
  _currentUserId: string;
   baseUrl : string ;
  constructor(
    public http: HttpClient,
    // private logger: LogService,
  //   private secureGuard: SecureGuardService,

  ) {
 //  this._currentUser = JSON.parse(localStorage.getItem('currentUser')) as User;
 //  this._currentUserId = this._currentUser.userId;
 //  this._currentUserEmail = this._currentUser.email;
   }

   get<T>(url: string, secure: boolean, mock?: T): Observable<T> {
    const fullUrl = `${environment.api}/${url}`;
    if (environment.online) {
      return this.http.get<T>(fullUrl, this.getHeaders(secure))
        .pipe(
          // tap(g => this.logger.log('SharedService', `get from [${url}] successfully!`)),
          catchError(e => this.httpError<T>('SharedService', `GET[${url}]`, e))
        );
    } else {
      // this.logger.log('SharedService', `(OFFLINE)get from [${url}] successfully!`);
      return of(mock as T);
    }
  }

  post<T>(entity: T, url: string, secure: boolean): Observable<T> {
    if (environment.online) {
      return this.http.post<T>(`${environment.api}/${url}`, entity, this.getHeaders(secure))
        .pipe(
          // tap(p => this.logger.log('SharedService', `post to [${url}] successfully!`)),
          catchError(e => this.httpError<T>('SharedService', `POST[${url}]`, e))
       );
    } else {
     // this.logger.log('SharedService', `(OFFLINE)post to [${url}] successfully!`);
      return of(entity as T);
    }
  }

  delete<T>(id: string, url: string, secure: boolean): Observable<T> {
    if (environment.online) {
     return this.http.delete<T>(`${environment.api}/${url}/${id}`, this.getHeaders(secure))
       .pipe(
        // tap(d => this.logger.log('SharedService', `delete from [${url}] successfully!`)),
         catchError(e => this.httpError<T>('SharedService', `DELETE[${url}]`, e))
       );
    } else {
      return of(null);
    }
  }

  getHeaders(secure: boolean) {
    if (secure) {
      return this.jwtHeaders();
    } else {
      return this.headers();
   }
 }

   headers() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    };
  }

 jwtHeaders() {
  //   const currentUser: User = JSON.parse(localStorage.getItem('currentUser')) as User;
   return {
     headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      //   'Authorization': 'Bearer ' + currentUser.token
     })
    };
  }

  authHeader() {
  //  const currentUser: User = JSON.parse(localStorage.getItem('currentUser')) as User;
   return {
  //   'Authorization': 'Bearer ' + currentUser.token
  };
 }

  httpError<T>(module = 'ecahtegypt', operation = 'operation', err: any, result?: T): Observable<T> {
    if (err.status === 401) {
 //  this.secureGuard.login();
    } else {
      if (err) {
      //  this.logger.error(module, operation, err.message);
        if (err.error) {
        //  this.logger.error(module, operation, err.error.message);
        }
      }
    }
    return of(result as T);
  }

  
  /*---------Switch lang Methods-------------*/
  switchLang(lang: string) {
    lang == 'AR' ? lang = 'EN' : lang = 'AR';
    console.log(lang);
    return (lang);
  }
  /*---------------------------------------------*/
}
